<ng-container *ngIf="(isLanding$ | async) && !(loading$ | async)">
  <am-header-landing></am-header-landing>
</ng-container>
<div class="results mb-grid-container-full">
  <ng-container *ngIf="(viewMap$ | async) === false; else viewMapTemplate">
    <am-filters-menu (showFilters)="toggleShowFilters()"></am-filters-menu>
    <div class="results__content mb-grid-col-12-dt">
      <div class="mb-grid-col-3-dt">
        <div class="results__content__header__title">
          <h1>
            <span *ngIf="showHotelsIn$ | async" i18n="@@hotel__in">Hoteles en</span><span class="--capitalize">
              {{ ((loading$ | async) && '...') || (entity$ | async)?.name }}</span>
          </h1>
        </div>


        <ng-container *ngIf="filters$ | async as filters">
          <am-filter-list *ngIf="filters && showFilters" [filtersList]="filters?.list" [allFilterList]="listFilter"
            [appliedFilters]="filters?.applied" [isMobile]="true" (closeFilters)="toggleShowFilters()"></am-filter-list>
        </ng-container>

      </div>
      <div class="results__hotels-list mb-grid-col-9-dt mb-grid-col-12">
        <am-banner-benefit-disney
          *ngIf="showBannerDisney && disneySearch && (hotels$ | async)?.length > 0"></am-banner-benefit-disney>
        <ng-container *ngIf="isAlliance">
          <div class="results__hotels-list__header__alliances-slider am-slider-container">
            <am-alliances-slider></am-alliances-slider>
          </div>
        </ng-container>
        <div class="results__hotels-list__header__sorting">
          <div class="results__hotels-list__header__sorting__filters">
            <am-price-by *ngIf="!(isLanding$ | async)"
              [disabled]="(loading$ | async) || !(hotels$ | async)?.length"></am-price-by>
          </div>


        </div>
        <mb-alert class="results__alert" type="notification" *ngIf="
            (loading$ | async) !== true && (customBanner$ | async) && (hotels$ | async)?.length
          ">
          <mb-alert-description>{{ (customBanner$ | async)?.text }}</mb-alert-description>
        </mb-alert>
        <ng-container *ngIf="loading$ | async; else amHotels">
          <am-hotels-list-skeleton></am-hotels-list-skeleton>
        </ng-container>
        <ng-template #amHotels>
          <ng-container *ngIf="(hotels$ | async) && !!(hotels$ | async)?.length; else errorNoResults">
            <am-hotels-list [hotels]="hotels$ | async" class="ng-star-inserted mb-grid-container-full">
              ></am-hotels-list>
            <am-paginator *ngIf="pagination$ | async as pagination" [pagination]="pagination"></am-paginator>
            <ng-container *ngIf="seo?.destination?.name || seo?.destination?.description">
              <am-seo-search [destination]="seo.destination"></am-seo-search>
            </ng-container>

            <ng-container *ngIf="isLanding$ | async">
              <am-interlinking></am-interlinking>
            </ng-container>
          </ng-container>
          <ng-template #errorNoResults>
            <am-error-no-results [appliedFilters]="!!(filters$ | async)?.applied?.length" [error]="error$ | async"
              [locale]="(context$ | async)?.locale"></am-error-no-results>
          </ng-template>
        </ng-template>
      </div>
    </div>
  </ng-container>
  <ng-template #viewMapTemplate>
    <div class="results__view-map mb-grid-container-full mb-grid-row">
      <div class="results__view-map__container-mobile mb-grid-col-4">
        <ng-container *ngIf="filters$ | async as filters">
          <div class="results__view-map__container-mobile__filters mb-grid-container-full">
            <am-filters-menu (showFilters)="toggleShowFilters()" [map]="true"></am-filters-menu>
            <am-filter-list *ngIf="filters && showFilters" [filtersList]="filters?.list"
              [appliedFilters]="filters?.applied" [isMobile]="true" [allFilterList]="listFilter"
              (closeFilters)="toggleShowFilters()">
            </am-filter-list>
          </div>
        </ng-container>
        <div class="results__view-map__container-mobile__map mb-grid-container-full" *ngIf="!showFilters">
          <am-hotels-map></am-hotels-map>
        </div>
      </div>

    </div>
  </ng-template>
</div>
<div (click)="(trackContactRowClick)">
  <!--am-experts-communications *ngIf="context$ | async as context" [channel]="context?.channel">
  </!--am-experts-communications-->
</div>